<div class="relative container mx-auto mt-12 space-y-8">
  <div
    class="flex flex-col rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10"
  >
    <h2 class="mb-4 text-3xl text-zinc-900 dark:text-zinc-200">User Profile</h2>
    <div
      class="flex flex-col rounded-xl p-4 ring-1 ring-zinc-900/15 md:flex-row md:p-8 dark:ring-white/10"
    >
      <div
        class="mb-2 border-b border-zinc-900/15 pb-2 md:mb-0 md:border-r md:border-b-0 md:pb-0 dark:border-white/10"
      >
        <div
          class="flex justify-center gap-4 py-2 text-center text-sm md:flex-col md:justify-end md:py-4 md:pe-6 md:text-start md:text-base"
        >
          <span
            [class.font-bold]="selectedOption == 'change-email'"
            (click)="selectedOption = 'change-email'"
            class="transition duration-100 hover:scale-105 hover:cursor-pointer"
          >
            Change Email
          </span>
          <span
            [class.font-bold]="selectedOption == 'change-password'"
            (click)="selectedOption = 'change-password'"
            class="transition duration-100 hover:scale-105 hover:cursor-pointer"
          >
            Change Password
          </span>
        </div>
      </div>
      <div class="py-2 md:py-4 md:ps-6">
        <!-- email change form -->
        <app-email-change-form
          [authenticatedUser]="authenticatedUser"
          *ngIf="selectedOption == 'change-email'"
        >
        </app-email-change-form>

        <!-- password change form -->
        <app-password-change-form
          [user]="authenticatedUser"
          [passwordRecovery]="false"
          (passwordChanged)="passwordChanged($event)"
          *ngIf="selectedOption == 'change-password'"
        >
        </app-password-change-form>
      </div>
    </div>
  </div>
</div>
